import html from '../legacy/ps.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function ProbStats() {
  return <LegacyHtmlPage slug="ps" title="Probability & Statistics" html={html} />;
}
